<template>
    <div class="px-3 py-2">
        <b-sidebar aria-labelledby="sidebar-no-header-title" width="700px" no-header id="employee_overtime_payment" backdrop style="direction:ltr" right :title="$parent.lang.overtime_payment" shadow>
            <template #default="{ hide }">
                <div class="m-1 text-start" :style="`direction:`+$parent.lang.dir">
                    <div style="width:170px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span style="font-size:.8em;">{{ $parent.lang.overtime_payment }}</span>
                    </div>
                    <div @click="hide" id="overtimePayHide" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{ $parent.lang.close }}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="px-3 py-2" :style="`direction:`+$parent.lang.dir">
                    <v-form ref="overtimePaymentForm">
                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ $parent.lang.date }}</label>
                                <b-form-input class="inborder" v-model="payment_date" type="date"></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ $parent.lang.remain }}</label>
                                <b-form-input class="inborder" :value="remainingAmount" readonly></b-form-input>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ $parent.lang.payment_type }}</label>
                                <b-input-group>
                                    <b-form-select
                                        class="selborder"
                                        v-model="payment_type"
                                        :options="paytypes"
                                    ></b-form-select>
                                    <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                        <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ $parent.lang.payment }}</label>
                                <b-form-select
                                    class="selborder"
                                    v-model="payment_mode"
                                    :options="paymentModes"
                                    @change="syncAmount"
                                ></b-form-select>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ $parent.lang.amount }}</label>
                                <b-form-input
                                    class="inborder"
                                    v-model="amount"
                                    type="number"
                                    min="0"
                                    :readonly="payment_mode === 'full'"
                                ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="12" sm="12">
                                <label>{{ $parent.lang.notes }}</label>
                                <b-form-textarea class="inborder" v-model="notes"></b-form-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" variant="success" @click="addit()" class="ma-2" style="width:100px;">{{ $parent.lang.save }}</b-button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';

export default{
    data() {
        return {
            empid: 0,
            month: '',
            year: '',
            remainingAmount: 0,
            amount: 0,
            payment_mode: 'full',
            payment_type: 1,
            payment_date: new Date().toISOString().substr(0, 10),
            notes: '',
            paytypes: []
        }
    },
    computed: {
        paymentModes() {
            return [
                { text: this.$parent.lang.full_payment, value: 'full' },
                { text: this.$parent.lang.partial_payment, value: 'partial' }
            ];
        }
    },
    created(){
        this.getPyamentType();
    },
    methods: {
        open(data) {
            this.empid = data.empid;
            this.month = data.month;
            this.year = data.year;
            this.remainingAmount = this.$RoundNum(parseFloat(data.remainingAmount || 0));
            this.payment_mode = 'full';
            this.amount = this.remainingAmount;
            this.notes = '';
            this.payment_date = new Date().toISOString().substr(0, 10);
        },
        syncAmount() {
            if(this.payment_mode === 'full'){
                this.amount = this.remainingAmount;
            }
        },
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.paytypes = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.paytypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                }
                if(res.results.data.length > 0){
                    this.payment_type = res.results.data[0].id;
                }
            })
        },
        addit() {
            let paymentAmount = parseFloat(this.amount || 0);
            const maxAmount = parseFloat(this.remainingAmount || 0);
            if(this.payment_mode === 'full'){
                paymentAmount = maxAmount;
            }
            if(paymentAmount <= 0 || maxAmount <= 0){
                this.notify(this.$parent.lang.mor_than_zero);
                return false;
            }
            if(paymentAmount > maxAmount){
                paymentAmount = maxAmount;
                this.amount = maxAmount;
            }

            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","payEmployeeOvertime");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append("data[empid]",this.empid);
            post.append("data[month]",this.month);
            post.append("data[year]",this.year);
            post.append("data[amount]",paymentAmount);
            post.append("data[paytype]",this.payment_type);
            post.append("data[payment_date]",this.payment_date);
            post.append("data[notes]",this.notes);

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const errorNumber = response.data && response.data.error ? parseInt(response.data.error.number) : 200;
                if(errorNumber !== 200){
                    this.notify(response.data.error.message || this.$parent.lang.overtime_payment_failed);
                    return false;
                }
                this.notify(this.$parent.lang.addes_successfuly);
                this.$parent.getEmployees();
                document.getElementById('overtimePayHide').click();
            })
        },
        notify(message) {
            this.$snotify.error(message, this.$parent.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.$parent.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
        }
    },
}
</script>
